import { useQuery } from '@tanstack/react-query';

import { getHttpStatus } from '../../../lib/apiError';
import type { InvitationPreviewOutput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/auth/invitation/:token/account/:accountKey` (public) — pré-remplit
 * l'écran d'acceptation. 404 `PASSENGER_ACCOUNT_NOT_FOUND` si le lien est invalide.
 */
export const useInvitationPreview = (token: string | null, accountKey: string | null) =>
  useQuery({
    queryKey: extranetQueryKeys.publicInvitation.preview(token ?? '', accountKey ?? ''),
    queryFn: () =>
      getExtranetApi().get<Record<string, never>, InvitationPreviewOutput>(
        `/v1/auth/invitation/${encodeURIComponent(token!)}/account/${encodeURIComponent(accountKey!)}`,
        {},
        { skipAuth: true },
      ),
    enabled: Boolean(token && accountKey),
    retry: (failureCount, error) => getHttpStatus(error) === undefined && failureCount < 2,
  });
